import pandaPayLoader from './utils/lib/PandaPayLoader';
import pageData, { isReactIframeIntegration } from './utils/pageData/pageData';
import config from './config';
import { fetchActions, parseActions } from './utils/old-riot-code/fetch-actions';
import onIframeComunication from './utils/iframeCommunication';
import watchVisible from './utils/old-riot-code/widget-visible';
import 'iframe-resizer';

import mainFile, { topLevelComponent } from './main';

import { adBlockCheck, trackAdBlock } from './utils/adBlock';
import staticData from './static_data/all';
import loadScript from './utils/scriptLoader';

// default export is used by react-static to generate static app
export default args => {
    return topLevelComponent(parseActions(staticData.actions));
};

function fetchActionData(page) {
    let prom;
    if (staticData.useStatic) {
        prom = Promise.resolve(staticData.actions).then(parseActions);
    } else {
        prom = fetchActions(
            config.API_BASE_URL,
            page.articleUrl,
            page.widgetPreviewId,
            page.widgetRequestId,
            page.embedType,
            page.isSponsoredContent === 'true'
        );
    }
    return prom.then(response => {
        if (response && response.actions && response.actions.length > 0) {
            if (response.isSponsored) {
                return adBlockCheck.then(isAdBlocked => {
                    if (isAdBlocked) {
                        trackAdBlock(response, page);
                        throw new Error('Ad blocker on sponsored widget.');
                    }
                    return response;
                });
            }
            return response;
        }

        throw new Error('No Button for this article');
    });
}

function initWidget(page) {
    return fetchActionData(page)
        .then(data => {
            if (data && data.cards && data.cards.length > 0) {
                pandaPayLoader.setPublicKey(config.PANDA_PAY_PUBLIC_KEY);

                mainFile(data, page);
                import('raven-js').then(Raven => {
                    Raven.config(
                        'https://bcdc7526b9c2419d9f7280658f36c835@sentry.io/217945',
                        { environment: config.SENTRY_ENV }
                    ).install();
                });
            }
        })
        .catch(err => console.log('No Action Button available', err));
}

function main() {
    loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${
            config.GOOGLE_MAPS_PUBLIC_KEY
        }&libraries=places`,
        null,
        true,
        true
    );

    if (isReactIframeIntegration()) {
        let isActionButtonInit = false;

        onIframeComunication(e => {
            if (e.data != null && (e.data.widgetId || e.data.articleUrl)) {
                if (isActionButtonInit) return;
                isActionButtonInit = true;
                e.data.widgetContainerId = config.EMBED_ELEMENT;
                initWidget(e.data);
            }
        });
    } else {
        const page = pageData();

        initWidget(page).then(() => {
            if (typeof window !== 'undefined') {
                watchVisible(null, page.widgetContainer).then(() => {
                    window.postMessage(
                        { isActionButtonWidgetVisible: true },
                        window.origin
                    );
                });
            }
        });
    }
}

function browserSupportsAllFeatures() {
    if (typeof window !== 'undefined') {
        return (
            window.Promise &&
            window.fetch &&
            typeof Object.assign === 'function' &&
            Array.prototype.find
        );
    }
    return false;
}

// if we're in a browser, let's actually run things now
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (browserSupportsAllFeatures()) {
        // Browsers that support all features run `main()` immediately.
        main();
    } else {
        // All other browsers loads polyfills and then run `main()`.
        loadScript(
            'https://cdn.polyfill.io/v2/polyfill.min.js?features=Promise,fetch,Object.assign,Array.prototype.find',
            main
        );
    }

    document.oncontextmenu = function() {
        return (
            typeof window !== 'undefined' &&
            (window.location.hostname === 'qa-native.actionbutton.co' ||
                window.location.hostname === 'localhost')
        );
    };
}
